import React from 'react';

export const SaveCardContext = React.createContext({
    showSaveCardMessage: false,
    setShowSaveCardMessage: () => { },
});


export const useSaveCardMessage = () => {
    const context = React.useContext(SaveCardContext);

    if (!context) {
        throw new Error('useSaveCardContext must be used within a SaveCardContext.provider');
    }

    return context;
};

export const useShowSaveCard = () => {
    const { showSaveCardMessage } = useSaveCardMessage();
    return showSaveCardMessage;
};

export const useSetShowSaveCard = () => {
    const { setShowSaveCardMessage } = useSaveCardMessage();
    return setShowSaveCardMessage;
};
